import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { ChangeStatus } from '@frontend/sync/types';
import React from 'react';

const ID = 'change-status-select';
export interface ChangeStatusSelectProps extends Omit<SelectInputV2Props<ChangeStatus>, 'options'> {}
export const ChangeStatusSelect = (props: ChangeStatusSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Change status'}
            options={Object.values(ChangeStatus).map((c) => ({ label: c, value: c }))}
        />
    );
};
